import React, { useState } from 'react';
import { requestPasswordReset } from '../api';

function ForgotPassword({ onGoToLogin }) {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);

    try {
      const result = await requestPasswordReset(email.trim());
      setMessage(
        result.message ||
          'If an account exists for that email, you will receive a password reset link shortly.'
      );
    } catch (err) {
      setError(err.error || 'Unable to send a reset link. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <p className="brand">My Weed Buddy</p>
      <h1>Reset password</h1>
      <p className="subtitle">Enter your email and we will send you a link to choose a new password.</p>

      {message && <div className="success">{message}</div>}
      {error && <div className="error">{error}</div>}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="email">Email Address</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            required
            autoFocus
          />
        </div>

        <button type="submit" disabled={loading}>
          {loading ? 'Sending...' : 'Send reset link'}
        </button>
      </form>

      <p className="footer-link">
        Remember your password?{' '}
        <button type="button" onClick={onGoToLogin}>
          Sign in
        </button>
      </p>
    </div>
  );
}

export default ForgotPassword;
